module.exports = __webpack_public_path__ + "static/media/info-office.2e8b0392.jpg";